// components/common/ui/SimpleTable/useExportExcel.js
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

export const useExportExcel = (rows, activeRows, columns, columnVisibility, tableName) => {
  return async function exportExcel(selectedRows) {
    const visibleCols = columns.filter(
      (col) => columnVisibility[col.field] !== false
    );

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Dados");

    worksheet.columns = visibleCols.map(() => ({ width: 20 }));
    worksheet.addRow(visibleCols.map((c) => c.headerName || c.field));

    const dataToExport =
      selectedRows.length > 0
        ? rows.filter((r) => selectedRows.includes(r.id))
        : activeRows;

    dataToExport.forEach((row) => {
      worksheet.addRow(visibleCols.map((c) => row[c.field] ?? ""));
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, `${tableName || "dados"}.xlsx`);
  };
};
